import React, { useEffect } from 'react';
import { Box, Typography, useMediaQuery, useTheme } from '@mui/material';
import ReusableModal from './Modal';
import { useModal } from '../../../../layouts/MainLayout';
import { createPortal } from 'react-dom';

const StaffSuccessModal = ({ open, onClose, message, subMessage, headerBg, showCloseIcon }) => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));
  const isTablet = useMediaQuery(theme.breakpoints.between('sm', 'md'));
  const { setModalState } = useModal();

  useEffect(() => {
    if (open) {
      setModalState({ open: true, component: null, props: {} });
      document.body.style.overflow = 'hidden';
    } else {
      setModalState({ open: false, component: null, props: {} });
      document.body.style.overflow = 'auto';
    }
    return () => {
      document.body.style.overflow = 'auto'; // Cleanup on unmount
    };
  }, [open, setModalState]);

  if (!open) return null;

  return createPortal(
    <Box
      sx={{
        position: 'fixed',
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        zIndex: 24000, // Match DeleteModal's zIndex
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        backgroundColor: 'rgba(0, 0, 0, 0.5)', // Add backdrop
        pointerEvents: 'auto',
      }}
      onClick={(e) => {
        if (e.target === e.currentTarget) onClose(); // Close on backdrop click
      }}
    >
      <ReusableModal
        open={open}
        onClose={onClose}
        maxWidth="sm"
        title='Successful'
        // style={{
        //   width: isMobile ? '300px' : isTablet ? '300px' : '300px',
        // }}
        headerPadding={{ pb: '5px',pt:0, px: 1 }}
        customWidth={{
          xs: '80%',
          sm: '300px',
          md: '300px',
          lg: '300px',
          xl: '300px',
        }}
      >
        <Box textAlign="center" pt={2.25}>
          <svg width="40" height="40" viewBox="0 0 52 52" style={{ overflow: "visible" }}>
            {/* Circle */}
            <circle
              cx="26"
              cy="26"
              r="25"
              fill="none"
              stroke={theme.palette.background.bggreen || theme.palette.success.main}
              strokeWidth="3"
              strokeDasharray="157"
              strokeDashoffset="157"
              style={{
                animation: 'drawCircle 0.6s ease-out forwards'
              }}
            />
            {/* Check */}
            <path
              fill="none"
              stroke={theme.palette.background.bggreen || theme.palette.success.main}
              strokeWidth="3"
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeDasharray="36"
              strokeDashoffset="36"
              d="M14 27 l7 7 l16 -16"
              style={{
                animation: 'drawCheck 0.4s ease-out 0.6s forwards'
              }}
            />
            <style>
              {`
                @keyframes drawCircle {
                  from { stroke-dashoffset: 157; }
                  to { stroke-dashoffset: 0; }
                }
                @keyframes drawCheck {
                  from { stroke-dashoffset: 36; }
                  to { stroke-dashoffset: 0; }
                }
              `}
            </style>
          </svg>
        </Box>
        <Typography
                  variant="h6"
                  className="fs-16"
                  fontWeight={700}
                  lineHeight={'18px'}
                  textAlign="center"
                  whiteSpace={'normal'}
                  mb={1}
                  mt={1}
                  color={theme.palette.custom.TableheadText}
                >
                  {message}
                </Typography>
                <Typography
                  variant="h6"
                  className="fs-16"
                  fontWeight={500}
                  lineHeight={'18px'}
                  textAlign="center"
                  whiteSpace={'normal'}
                  mb={1}
                  mt={1}
                  color={theme.palette.custom.TableheadText}
                  sx={{ whiteSpace: 'pre-line' }}
                >
                  {subMessage}
                </Typography>
      </ReusableModal>
    </Box>,
    document.body
  );
};

export default StaffSuccessModal;